import { PermissionLevel, plan_mapping } from './constants';
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Subject } from "rxjs";
import { environment } from "src/environments/environment";
import { GetUpgradedChatList, ListGeoLocation, SelectChat, SetSignupStatus, ListBranchUser, ListAccountMenu, GetAccountMenu, DeleteAccountMenu } from "./outbound";
import { IndexDBService } from "./indexDB.service";
import { MenuButton, Message, Page } from "./interface";
import { LoaderService } from "./loader.service";
import { EventService } from "./event.service";
import { SERVER_ERROR_MESSAGES, ServerErrors } from "./server-errors.enum";
import Swal from "sweetalert2";

@Injectable({
  providedIn: "root",
})


export class WebsocketService {
  ws: any;
  url = environment.ws_url;
  pingInterval: any;
  verified = false;
  component_ref = this.mdw.makeRef(16);

  public _selectedChatContainer = new BehaviorSubject<any>(undefined);
  public selectedChatContainer$ = this._selectedChatContainer.asObservable();
  public _getChatListContainer = new BehaviorSubject<any>(undefined);
  public getChatListContainer$ = this._getChatListContainer.asObservable();
  public _listUsersContainer = new Subject<any>();
  public listUsersContainer$ = this._listUsersContainer.asObservable();
  public _whiteListUsersContainer = new Subject<any>();
  public whiteListUsersContainer$ = this._whiteListUsersContainer.asObservable();
  public _blackListUsersContainer = new Subject<any>();
  public blackListUsersContainer$ = this._blackListUsersContainer.asObservable();
  public _listChannelsContainer = new Subject<any>();
  public listChannelsContainer$ = this._listChannelsContainer.asObservable();
  public _listChatsContainer = new Subject<any>();
  public listChatsContainer$ = this._listChatsContainer.asObservable();
  public _chatInvalidContainer = new Subject<any>();
  public chatInvalidContainer$ = this._chatInvalidContainer.asObservable();
  public _chatDetailsContainer = new Subject<any>();
  public chatDetailsContainer$ = this._chatDetailsContainer.asObservable();
  public _groupDeletedContainer = new Subject<any>();
  public groupDeletedContainer$ = this._groupDeletedContainer.asObservable();
  public _bookingExceptionsContainer = new Subject<any>();
  public bookingExceptionsContainer$ = this._bookingExceptionsContainer.asObservable();
  public _bookingPeriodsContainer = new Subject<any>();
  public bookingPeriodsContainer$ = this._bookingPeriodsContainer.asObservable();
  public _listChatTagsContainer = new Subject<any>();
  public listChatTagsContainer$ = this._listChatTagsContainer.asObservable();
  public _messageTagsContainer = new Subject<any>();
  public messageTagsContainer$ = this._messageTagsContainer.asObservable();
  public _appBuilderContainer = new Subject<any>();
  public appBuilderContainer$ = this._appBuilderContainer.asObservable();
  public _listgroupsContainer = new Subject<any>();
  public listgroupsContainer$ = this._listgroupsContainer.asObservable();
  public _listbookingsContainer = new Subject<any>();
  public listbookingsContainer$ = this._listbookingsContainer.asObservable();
  public _listEventsContainer = new Subject<any>();
  public listEventsContainer$ = this._listEventsContainer.asObservable();
  public _listCouponsContainer = new Subject<any>();
  public listCouponsContainer$ = this._listCouponsContainer.asObservable();
  public _listCampaignsContainer = new Subject<any>();
  public listCampaignsContainer$ = this._listCampaignsContainer.asObservable();
  public _listPollsContainer = new Subject<any>();
  public listPollsContainer$ = this._listPollsContainer.asObservable();
  public _listProductContainer = new Subject<any>();
  public listProductContainer$ = this._listProductContainer.asObservable();
  public _listCollectionContainer = new Subject<any>();
  public listCollectionContainer$ = this._listCollectionContainer.asObservable();
  public _listPaymentOrdersContainer = new Subject<any>();
  public listPaymentOrdersContainer$ = this._listPaymentOrdersContainer.asObservable();
  public _listStoreContainer = new Subject<any>();
  public listStoreContainer$ = this._listStoreContainer.asObservable();
  public _getStoreContainer = new Subject<any>();
  public getStoreContainer$ = this._getStoreContainer.asObservable();


  public _getProfileContainer = new Subject<any>();
  public getProfileContainer$ = this._getProfileContainer.asObservable();
  public _getQrcodeContainer = new Subject<any>();
  public getQrcodeContainer$ = this._getQrcodeContainer.asObservable();
  public _myDomainsContainer = new Subject<any>();
  public myDomainsContainer$ = this._myDomainsContainer.asObservable();
  public _listMyExchangeDomainsContainer = new Subject<any>();
  public listMyExchangeDomainsContainer$ = this._listMyExchangeDomainsContainer.asObservable();
  public _searchDomainsContainer = new Subject<any>();
  public searchDomainsContainer$ = this._searchDomainsContainer.asObservable();
  public _getDomainContainer = new Subject<any>();
  public getDomainContainer$ = this._getDomainContainer.asObservable();
  public _getMyDomainContainer = new Subject<any>();
  public getMyDomainContainer$ = this._getMyDomainContainer.asObservable();
  public _getOrderContainer = new Subject<any>();
  public getOrderContainer$ = this._getOrderContainer.asObservable();
  public _getOtherServiceContainer = new Subject<any>();
  public getOtherServiceContainer$ = this._getOtherServiceContainer.asObservable();
  public _getChatContainer = new Subject<any>();
  public getChatContainer$ = this._getChatContainer.asObservable();
  public _getMessageContainer = new Subject<any>();
  public getMessageContainer$ = this._getMessageContainer.asObservable();
  public _otherAccountOnlineContainer = new Subject<any>();
  public otherAccountOnlineContainer$ = this._otherAccountOnlineContainer.asObservable();
  public _senderVerifyServiceContainer = new Subject<any>();
  public senderVerifyServiceContainer$ = this._senderVerifyServiceContainer.asObservable();
  public _receiverVerifyServiceContainer = new Subject<any>();
  public receiverVerifyServiceContainer$ = this._receiverVerifyServiceContainer.asObservable();
  public _testContainer = new Subject<any>();
  public testContainer$ = this._testContainer.asObservable();
  public _myOrdersContainer = new Subject<any>();
  public myOrdersContainer$ = this._myOrdersContainer.asObservable();
  public _highlightContainer = new Subject<any>();
  public highlightContainer$ = this._highlightContainer.asObservable();
  public _rechargeContainer = new Subject<any>();
  public rechargeContainer$ = this._rechargeContainer.asObservable();
  public _createPaymentContainer = new Subject<any>();
  public createPaymentContainer$ = this._createPaymentContainer.asObservable();
  public _paymentFeesContainer = new Subject<any>();
  public paymentFeesContainer$ = this._paymentFeesContainer.asObservable();
  public _payoutContainer = new Subject<any>();
  public payoutContainer$ = this._payoutContainer.asObservable();
  public _billingHistoryContainer = new Subject<any>();
  public billingHistoryContainer$ = this._billingHistoryContainer.asObservable();

  public _getMyProfileContainer = new BehaviorSubject<any>(undefined);
  public getMyProfileContainer$ = this._getMyProfileContainer.asObservable();
  public _verifyContainer = new BehaviorSubject<any>(false);
  public verifyContainer$ = this._verifyContainer.asObservable();
  public _loginVerifyContainer = new BehaviorSubject<any>(false);
  public loginVerifyContainer$ = this._loginVerifyContainer.asObservable();

  public _getBalanceContainer = new BehaviorSubject<any>(undefined);
  public getBalanceContainer$ = this._getBalanceContainer.asObservable();

  public _messageUpdateContainer = new BehaviorSubject<Message>(undefined);
  public messageUpdateContainer$ = this._messageUpdateContainer.asObservable();

  public _incomingMessageContainer = new Subject<Message>();
  public incomingMessageContainer$ = this._incomingMessageContainer.asObservable();

  public _messageScheduleUpdateContainer = new BehaviorSubject<Message>(undefined);
  public messageScheduleUpdateContainer$ = this._messageScheduleUpdateContainer.asObservable();

  public _messageListResponeContainer = new Subject<any>();
  public messageListResponeContainer$ = this._messageListResponeContainer.asObservable();

  public _messageListEopContainer = new Subject<any>();
  public messageListEopContainer$ = this._messageListEopContainer.asObservable();

  public _messageListLevel1ResponeContainer = new BehaviorSubject<any>(undefined);
  public messageListLevel1ResponeContainer$ = this._messageListLevel1ResponeContainer.asObservable();

  public _fileUploadComponentContainer = new BehaviorSubject<any>(undefined);
  public fileUploadComponentContainer$ = this._fileUploadComponentContainer.asObservable();

  public _menuPageResponseContainer = new BehaviorSubject<any>(undefined);
  public menuPageResponseContainer$ = this._menuPageResponseContainer.asObservable();

  public _myGalleryContainer = new BehaviorSubject<any>(undefined);
  public myGalleryContainer$ = this._myGalleryContainer.asObservable();

  public _deleteMyGalleryContainer = new BehaviorSubject<any>(undefined);
  public deleteMyGalleryContainer$ = this._deleteMyGalleryContainer.asObservable();

  public _appReleasesContainer = new BehaviorSubject<any>(undefined);
  public appReleasesContainer$ = this._appReleasesContainer.asObservable();

  public _getAppsContainer = new BehaviorSubject<any>(undefined);
  public getAppsContainer$ = this._getAppsContainer.asObservable();

  public _getAppReleaseContainer = new BehaviorSubject<any>(undefined);
  public getAppReleaseContainer$ = this._getAppReleaseContainer.asObservable();

  public _getAppStoreContainer = new BehaviorSubject<any>(undefined);
  public getAppStoreContainer$ = this._getAppStoreContainer.asObservable();

  public _getAppsSetupContainer = new BehaviorSubject<any>(undefined);
  public getAppsSetupContainer$ = this._getAppsSetupContainer.asObservable();

  public _requestAppleCodeContainer = new BehaviorSubject<any>(undefined);
  public requestAppleCodeContainer$ = this._requestAppleCodeContainer.asObservable();

  public _appSetupContainer = new BehaviorSubject<any>(undefined);
  public appSetupContainer$ = this._appSetupContainer.asObservable();

  public _setAppConfigResponseContainer = new Subject<any>();
  public setAppConfigResponseContainer$ = this._setAppConfigResponseContainer.asObservable();

  public _publishAppConfigResponseContainer = new BehaviorSubject<any>(undefined);
  public publishAppConfigResponseContainer$ = this._publishAppConfigResponseContainer.asObservable();

  public _getMyMediaResponseContainer = new BehaviorSubject<any>(undefined);
  public getMyMediaResponseContainer$ = this._getMyMediaResponseContainer.asObservable();

  public _listBotsResponseContainer = new BehaviorSubject<any>(undefined);
  public listBotsResponseContainer$ = this._listBotsResponseContainer.asObservable();

  public _getMyBotResponseContainer = new BehaviorSubject<any>(undefined);
  public getMyBotResponseContainer$ = this._getMyBotResponseContainer.asObservable();

  public _botTemplatesContainer = new BehaviorSubject<any>(undefined);
  public botTemplatesContainer$ = this._botTemplatesContainer.asObservable();

  public _calendarContainer = new Subject<any>();
  public calendarContainer$ = this._calendarContainer.asObservable();

  public _listCalendarsContainer = new Subject<any>();
  public listCalendarsContainer$ = this._listCalendarsContainer.asObservable();

  public _calendarDetailsContainer = new Subject<any>();
  public calendarDetailsContainer$ = this._calendarDetailsContainer.asObservable();

  public _setProductItemContainer = new Subject<any>();
  public setProductItemContainer$ = this._setProductItemContainer.asObservable();

  public _getProductItemContainer = new Subject<any>();
  public getProductItemContainer$ = this._getProductItemContainer.asObservable();

  public _getStockContainer = new Subject<any>();
  public getStockContainer$ = this._getStockContainer.asObservable();

  public _setProductItemArrayContainer = new Subject<any>();
  public setProductItemArrayContainer$ = this._setProductItemArrayContainer.asObservable();

  public _myProfileContainer = new Subject<any>();
  public myProfileContainer$ = this._myProfileContainer.asObservable();

  public _setCatalogContainer = new Subject<any>();
  public setCatalogContainer$ = this._setCatalogContainer.asObservable();

  public _getCatalogContainer = new Subject<any>();
  public getCatalogContainer$ = this._getCatalogContainer.asObservable();

  public _listCatalogContainer = new Subject<any>();
  public listCatalogContainer$ = this._listCatalogContainer.asObservable();

  public _deleteCatalogContainer = new Subject<any>();
  public deleteCatalogContainer$ = this._deleteCatalogContainer.asObservable();

  public _setCollectionItemContainer = new Subject<any>();
  public setCollectionItemContainer$ = this._setCollectionItemContainer.asObservable();

  public _getCollectionItemContainer = new Subject<any>();
  public getCollectionItemContainer$ = this._getCollectionItemContainer.asObservable();

  public _setCollectionProductContainer = new Subject<any>();
  public setCollectionProductContainer$ = this._setCollectionProductContainer.asObservable();

  public _createArticleACKContainer = new Subject<any>();
  public createArticleACKContainer$ = this._createArticleACKContainer.asObservable();

  public _setUserCouponContainer = new Subject<any>();
  public setUserCouponContainer$ = this._setUserCouponContainer.asObservable();

  public _getUserContainer = new Subject<any>();
  public getUserContainer$ = this._getUserContainer.asObservable();

  public _getMyMemberChatsContainer = new Subject<any>();
  public getMyMemberChatsContainer$ = this._getMyMemberChatsContainer.asObservable();

  public _addChatMemberContainer = new Subject<any>();
  public addChatMemberContainer$ = this._addChatMemberContainer.asObservable();

  public _likeMessageAckContainer = new Subject<any>();
  public likeMessageAckContainer$ = this._likeMessageAckContainer.asObservable();

  public _chatCountersContainer = new Subject<any>();
  public chatCountersContainer$ = this._chatCountersContainer.asObservable();

  public _getListChatTagsContainer = new Subject<any>();
  public getListChatTagsContainer$ = this._getListChatTagsContainer.asObservable();

  public _chatTagsContainer = new Subject<any>();
  public chatTagsContainer$ = this._chatTagsContainer.asObservable();

  public _verificationTemplateContainer = new Subject<any>();
  public verificationTemplateContainer$ = this._verificationTemplateContainer.asObservable();

  public _smtpConfigContainer = new Subject<any>();
  public smtpConfigContainer$ = this._smtpConfigContainer.asObservable();

  public _messagingVendorContainer = new Subject<any>();
  public messagingVendorContainer$ = this._messagingVendorContainer.asObservable();

  public _signedUpDemoAccountContainer = new Subject<any>();
  public signedUpDemoAccountContainer$ = this._signedUpDemoAccountContainer.asObservable();

  public _registeredDemoAccountContainer = new Subject<any>();
  public registeredDemoAccountContainer$ = this._registeredDemoAccountContainer.asObservable();

  public _testedMessagingVendorContainer = new Subject<any>();
  public testedMessagingVendorContainer$ = this._testedMessagingVendorContainer.asObservable();

  public _sendEmailContainer = new Subject<any>();
  public sendEmailContainer$ = this._sendEmailContainer.asObservable();

  public _listEmailsContainer = new Subject<any>();
  public listEmailsContainer$ = this._listEmailsContainer.asObservable();

  public _emailDetailsContainer = new Subject<any>();
  public emailDetailsContainer$ = this._emailDetailsContainer.asObservable();

  public _deleteEmailsFromHistoryContainer = new Subject<any>();
  public deleteEmailsFromHistoryContainer$ = this._deleteEmailsFromHistoryContainer.asObservable();

  public _sendSmsContainer = new Subject<any>();
  public sendSmsContainer$ = this._sendSmsContainer.asObservable();

  public _listSmsContainer = new Subject<any>();
  public listSmsContainer$ = this._listSmsContainer.asObservable();

  public _smsDetailsContainer = new Subject<any>();
  public smsDetailsContainer$ = this._smsDetailsContainer.asObservable();

  public _deleteSmsFromHistoryContainer = new Subject<any>();
  public deleteSmsFromHistoryContainer$ = this._deleteSmsFromHistoryContainer.asObservable();

  public _thirdPartyInfoContainer = new Subject<any>();
  public thirdPartyInfoContainer$ = this._thirdPartyInfoContainer.asObservable();

  public _paymentProvidersContainer = new Subject<any>();
  public paymentProvidersContainer$ = this._paymentProvidersContainer.asObservable();

  public _adsProvidersContainer = new Subject<any>();
  public adsProvidersContainer$ = this._adsProvidersContainer.asObservable();

  public _getPaymentInfoContainer = new BehaviorSubject<any>(undefined);
  public getPaymentInfoContainer$ = this._getPaymentInfoContainer.asObservable();

  public _getUpdatedPaymentInfoContainer = new Subject<any>();
  public getUpdatedPaymentInfoContainer$ = this._getUpdatedPaymentInfoContainer.asObservable();

  public _getInvoicesContainer = new Subject<any>();
  public getInvoicesContainer$ = this._getInvoicesContainer.asObservable();

  public _createCardContainer = new Subject<any>();
  public createCardContainer$ = this._createCardContainer.asObservable();

  public _setDefaultCardContainer = new Subject<any>();
  public setDefaultCardContainer$ = this._setDefaultCardContainer.asObservable();

  public _deleteCardContainer = new Subject<any>();
  public deleteCardContainer$ = this._deleteCardContainer.asObservable();

  public _retrieveCouponContainer = new Subject<any>();
  public retrieveCouponContainer$ = this._retrieveCouponContainer.asObservable();

  public _subscribeToAddonsCouponContainer = new Subject<any>();
  public subscribeToAddonsCouponContainer$ = this._subscribeToAddonsCouponContainer.asObservable();

  public _changePlanContainer = new Subject<any>();
  public changePlanContainer$ = this._changePlanContainer.asObservable();

  public _subscribeToPlanContainer = new Subject<any>();
  public subscribeToPlanContainer$ = this._subscribeToPlanContainer.asObservable();

  public _cancelStripeSubscriptionContainer = new Subject<any>();
  public cancelStripeSubscriptionContainer$ = this._cancelStripeSubscriptionContainer.asObservable();

  public _revokeSubscriptionContainer = new Subject<any>();
  public revokeSubscriptionContainer$ = this._revokeSubscriptionContainer.asObservable();

  public _getSignupPatternContainer = new Subject<any>();
  public getSignupPatternContainer$ = this._getSignupPatternContainer.asObservable();

  public _deleteSignupPatternContainer = new Subject<any>();
  public deleteSignupPatternContainer$ = this._deleteSignupPatternContainer.asObservable();

  public _setSignupPatternContainer = new Subject<any>();
  public setSignupPatternContainer$ = this._setSignupPatternContainer.asObservable();

  public _addWhitelistAckContainer = new Subject<any>();
  public addWhitelistAckContainer$ = this._addWhitelistAckContainer.asObservable();

  public _addBlacklistAckContainer = new Subject<any>();
  public addBlacklistAckContainer$ = this._addBlacklistAckContainer.asObservable();

  public _blacklistContainer = new Subject<any>();
  public blacklistContainer$ = this._blacklistContainer.asObservable();

  public _deleteWhitelistAckContainer = new Subject<any>();
  public deleteWhitelistAckContainer$ = this._deleteWhitelistAckContainer.asObservable();

  public _mediaFileContainer = new Subject<any>();
  public mediaFileContainer$ = this._mediaFileContainer.asObservable();

  public _getArticleContainer = new Subject<any>();
  public getArticleContainer$ = this._getArticleContainer.asObservable();

  public _listBranchContainer = new Subject<any>();
  public listBranchContainer$ = this._listBranchContainer.asObservable();

  public _setBranchContainer = new Subject<any>();
  public setBranchContainer$ = this._setBranchContainer.asObservable();

  public _getBranchContainer = new Subject<any>();
  public getBranchContainer$ = this._getBranchContainer.asObservable();

  public _deleteBranchContainer = new Subject<any>();
  public deleteBranchContainer$ = this._deleteBranchContainer.asObservable();

  public _setBranchUserContainer = new Subject<any>();
  public setBranchUserContainer$ = this._setBranchUserContainer.asObservable();

  public _removeBranchUserContainer = new Subject<any>();
  public removeBranchUserContainer$ = this._removeBranchUserContainer.asObservable();

  public _listBranchUserContainer = new Subject<any>();
  public listBranchUserContainer$ = this._listBranchUserContainer.asObservable();

  public _listVendorsContainer = new Subject<any>();
  public listVendorsContainer$ = this._listVendorsContainer.asObservable();

  public _setVendorContainer = new Subject<any>();
  public setVendorContainer$ = this._setVendorContainer.asObservable();

  public _getVendorContainer = new Subject<any>();
  public getVendorContainer$ = this._getVendorContainer.asObservable();

  public _deleteVendorContainer = new Subject<any>();
  public deleteVendorContainer$ = this._deleteVendorContainer.asObservable();

  public _listGeoLocationContainer = new Subject<any>();
  public listGeoLocationContainer$ = this._listGeoLocationContainer.asObservable();

  public _setGeoLocationContainer = new Subject<any>();
  public setGeoLocationContainer$ = this._setGeoLocationContainer.asObservable();

  public _deleteGeoLocationContainer = new Subject<any>();
  public deleteGeoLocationContainer$ = this._deleteGeoLocationContainer.asObservable();

  public _getGeoLocationContainer = new Subject<any>();
  public getGeoLocationContainer$ = this._getGeoLocationContainer.asObservable();

  public _deleteBlacklistAckContainer = new Subject<any>();
  public deleteBlacklistAckContainer$ = this._deleteBlacklistAckContainer.asObservable();

  public _appChannelSettingsContainer = new Subject<any>();
  public appChannelSettingsContainer$ = this._appChannelSettingsContainer.asObservable();

  public _maintenanceContainer = new Subject<any>();
  public maintenanceContainer$ = this._maintenanceContainer.asObservable();

  public _updateAppInfoContainer = new Subject<any>();
  public updateAppInfoContainer$ = this._updateAppInfoContainer.asObservable();

  public _processMakerCheckerRecordContainer = new Subject<any>();
  public processMakerCheckerRecordContainer$ = this._processMakerCheckerRecordContainer.asObservable();

  public _botTokenContainer = new Subject<any>();
  public botTokenContainer$ = this._botTokenContainer.asObservable();

  public _chatWithAIContainer = new BehaviorSubject<any>(undefined);
  public chatWithAIContainer$ = this._chatWithAIContainer.asObservable();

  public _chatWithAIListContainer = new BehaviorSubject<any>(undefined);
  public chatWithAIListContainer$ = this._chatWithAIListContainer.asObservable();

  public _resetChatWithAIContainer = new BehaviorSubject<any>(undefined);
  public resetChatWithAIContainer$ = this._resetChatWithAIContainer.asObservable();

  public _sendChatToAIContainer = new Subject<any>();
  public sendChatToAIContainer$ = this._sendChatToAIContainer.asObservable();

  public _getUserListContainer = new Subject<any>();
  public getUserListContainer$ = this._getUserListContainer.asObservable();

  public _botResponceContainer = new Subject<any>();
  public botResponceContainer$ = this._botResponceContainer.asObservable();

  public _publishBotContainer = new Subject<any>();
  public publishBotContainer$ = this._publishBotContainer.asObservable();

  public _deleteProductElementContainer = new Subject<any>();
  public deleteProductElementContainer$ = this._deleteProductElementContainer.asObservable();

  public _cancelMessageScheduleContainer = new Subject<any>();
  public cancelMessageScheduleContainer$ = this._cancelMessageScheduleContainer.asObservable();

  public _setTaxContainer = new Subject<any>();
  public setTaxContainer$ = this._setTaxContainer.asObservable();

  public _setFeeContainer = new Subject<any>();
  public setFeeContainer$ = this._setFeeContainer.asObservable();

  public _getTaxContainer = new Subject<any>();
  public getTaxContainer$ = this._getTaxContainer.asObservable();

  public _getFeeContainer = new Subject<any>();
  public getFeeContainer$ = this._getFeeContainer.asObservable();

  public _setAppInfoContainer = new Subject<any>();
  public setAppInfoContainer$ = this._setAppInfoContainer.asObservable();

  public _getAppInfoContainer = new Subject<any>();
  public getAppInfoContainer$ = this._getAppInfoContainer.asObservable();

  public _listZonesContainer = new Subject<any>();
  public listZonesContainer$ = this._listZonesContainer.asObservable();

  public _setZoneContainer = new Subject<any>();
  public setZoneContainer$ = this._setZoneContainer.asObservable();

  public _getZoneContainer = new Subject<any>();
  public getZoneContainer$ = this._getZoneContainer.asObservable();

  public _deleteZoneContainer = new Subject<any>();
  public deleteZoneContainer$ = this._deleteZoneContainer.asObservable();

  public _getShippingContainer = new Subject<any>();
  public getShippingContainer$ = this._getShippingContainer.asObservable();

  public _setShippingContainer = new Subject<any>();
  public setShippingContainer$ = this._setShippingContainer.asObservable();

  public _setCategoryContainer = new Subject<any>();
  public setCategoryContainer$ = this._setCategoryContainer.asObservable();

  public _getCategoryContainer = new Subject<any>();
  public getCategoryContainer$ = this._getCategoryContainer.asObservable();

  public _listCategoryContainer = new Subject<any>();
  public listCategoryContainer$ = this._listCategoryContainer.asObservable();

  public _deleteCategoryContainer = new Subject<any>();
  public deleteCategoryContainer$ = this._deleteCategoryContainer.asObservable();

  public _botPublishedContainer = new Subject<any>();
  public botPublishedContainer$ = this._botPublishedContainer.asObservable();

  public _refreshSuccessContainer = new Subject<any>();
  public refreshSuccessContainer$ = this._refreshSuccessContainer.asObservable();

  public _getChatAdministratorsContainer = new Subject<any>();
  public getChatAdministratorsContainer$ = this._getChatAdministratorsContainer.asObservable();

  public _listPollContainer = new Subject<any>();
  public listPollContainer$ = this._listPollContainer.asObservable();

  public _pollContainer = new Subject<any>();
  public pollContainer$ = this._pollContainer.asObservable();

  public _deletePollContainer = new Subject<any>();
  public deletePollContainer$ = this._deletePollContainer.asObservable();

  public _deleteStoreContainer = new Subject<any>();
  public deleteStoreContainer$ = this._deleteStoreContainer.asObservable();

  public _deleteCollectionContainer = new Subject<any>();
  public deleteCollectionContainer$ = this._deleteCollectionContainer.asObservable();

  public _setStoreContainer = new Subject<any>();
  public setStoreContainer$ = this._setStoreContainer.asObservable();

  public _tokenChangeContainer = new Subject<any>();
  public tokenChangeContainer$ = this._tokenChangeContainer.asObservable();

  public _reconnectNoticeContainer = new Subject<any>();
  public reconnectNoticeContainer$ = this._reconnectNoticeContainer.asObservable();

  public _setAppConfigTemplateContainer = new Subject<any>();
  public setAppConfigTemplateContainer$ = this._setAppConfigTemplateContainer.asObservable();

  public _manageAppMemberContainer = new Subject<any>();
  public manageAppMemberContainer$ = this._manageAppMemberContainer.asObservable();

  public _deleteAppMemberContainer = new Subject<any>();
  public deleteAppMemberContainer$ = this._deleteAppMemberContainer.asObservable();

  public _deleteCouponResponseContainer = new Subject<any>();
  public deleteCouponResponseContainer$ = this._deleteCouponResponseContainer.asObservable();

  public _removeCalendarResponseContainer = new Subject<any>();
  public removeCalendarResponseContainer$ = this._removeCalendarResponseContainer.asObservable();

  public _getMapMarkersResponseContainer = new Subject<any>();
  public getMapMarkersResponseContainer$ = this._getMapMarkersResponseContainer.asObservable();

  public _mapMarkerResponseContainer = new Subject<any>();
  public mapMarkerResponseContainer$ = this._mapMarkerResponseContainer.asObservable();
  public _getUsersPaymentOrdersContainer = new Subject<any>();
  public getUsersPaymentOrdersContainer$ = this._getUsersPaymentOrdersContainer.asObservable();

  public _getOrderRequestContainer = new Subject<any>();
  public getOrderRequestContainer$ = this._getOrderRequestContainer.asObservable();

  public _getOrderRequestDetailsContainer = new Subject<any>();
  public getOrderRequestDetailsContainer$ = this._getOrderRequestDetailsContainer.asObservable();

  public _listOffersContainer = new Subject<any>();
  public listOffersContainer$ = this._listOffersContainer.asObservable();

  public _getOrderDetailsContainer = new Subject<any>();
  public getOrderDetailsContainer$ = this._getOrderDetailsContainer.asObservable();

  public _expiredContainer = new BehaviorSubject<any>(undefined);
  public expiredContainer$ = this._expiredContainer.asObservable();

  public _endTrialContainer = new BehaviorSubject<any>(undefined);
  public endTrialContainer$ = this._endTrialContainer.asObservable();


  public _maximumBuildContainer = new Subject<any>();
  public maximumBuildContainer$ = this._maximumBuildContainer.asObservable();

  public _responseAIContainer = new Subject<any>();
  public responseAIContainer$ = this._responseAIContainer.asObservable();

  public _getAIHistoryContainer = new Subject<any>();
  public getAIHistoryContainer$ = this._getAIHistoryContainer.asObservable();

  public _clearAIHistoryContainer = new Subject<any>();
  public clearAIHistoryContainer$ = this._clearAIHistoryContainer.asObservable();

  public _getAIDefinitionContainer = new Subject<any>();
  public getAIDefinitionContainer$ = this._getAIDefinitionContainer.asObservable();

  public _updateAIDefinitionContainer = new Subject<any>();
  public updateAIDefinitionContainer$ = this._updateAIDefinitionContainer.asObservable();

  public _getPollResultContainer = new Subject<any>();
  public getPollResultContainer$ = this._getPollResultContainer.asObservable();

  public _publishPollResultContainer = new Subject<any>();
  public publishPollResultContainer$ = this._publishPollResultContainer.asObservable();

  public _listRequestsToCheckContainer = new Subject<any>();
  public listRequestsToCheckContainer$ = this._listRequestsToCheckContainer.asObservable();

  public _checkUserRequestContainer = new Subject<any>();
  public checkUserRequestContainer$ = this._checkUserRequestContainer.asObservable();

  public _genStatesContainer = new BehaviorSubject<any>(undefined);
  public genStatesContainer$ = this._genStatesContainer.asObservable();

  public _searchItemsContainer = new BehaviorSubject<any>(undefined);
  public searchItemsContainer$ = this._searchItemsContainer.asObservable();

  public _getTagsValueContainer = new Subject<any>();
  public getTagsValueContainer$ = this._getTagsValueContainer.asObservable();

  public _listPartnersContainer = new Subject<any>();
  public listPartnersContainer$ = this._listPartnersContainer.asObservable();

  public _listAppFunnelContainer = new Subject<any>();
  public listAppFunnelContainer$ = this._listAppFunnelContainer.asObservable();

  public _listAppPaymentsContainer = new Subject<any>();
  public listAppPaymentsContainer$ = this._listAppPaymentsContainer.asObservable();

  public _listAppRevenueSummaryContainer = new Subject<any>();
  public listAppRevenueSummaryContainer$ = this._listAppRevenueSummaryContainer.asObservable();

  public _listFunnelMetricsContainer = new Subject<any>();
  public listFunnelMetricsContainer$ = this._listFunnelMetricsContainer.asObservable();

  public _listPaymentMetricsContainer = new Subject<any>();
  public listPaymentMetricsContainer$ = this._listPaymentMetricsContainer.asObservable();

  public _listPaymentRetentionSummaryContainer = new Subject<any>();
  public listPaymentRetentionSummaryContainer$ = this._listPaymentRetentionSummaryContainer.asObservable();

  public _listRevenueKpiSummaryContainer = new Subject<any>();
  public listRevenueKpiSummaryContainer$ = this._listRevenueKpiSummaryContainer.asObservable();

  public _listSignupConversionCohortsContainer = new Subject<any>();
  public listSignupConversionCohortsContainer$ = this._listSignupConversionCohortsContainer.asObservable();

  public _listSubscriptionMetricsContainer = new Subject<any>();
  public listSubscriptionMetricsContainer$ = this._listSubscriptionMetricsContainer.asObservable();

  public _listSignupSourceMetricsContainer = new Subject<any>();
  public listSignupSourceMetricsContainer$ = this._listSignupSourceMetricsContainer.asObservable();

  public _sendDeviceCalendarContainer = new Subject<any>();
  public sendDeviceCalendarContainer$ = this._sendDeviceCalendarContainer.asObservable();

  public _listFunnelKpiSummaryContainer = new Subject<any>();
  public listFunnelKpiSummaryContainer$ = this._listFunnelKpiSummaryContainer.asObservable();

  public _setAppBuildRateContainer = new Subject<any>();
  public setAppBuildRateContainer$ = this._setAppBuildRateContainer.asObservable();

  public _setAppPaymentDateContainer = new Subject<any>();
  public setAppPaymentDateContainer$ = this._setAppPaymentDateContainer.asObservable();

  public _getCustomerTokenContainer = new Subject<any>();
  public getCustomerTokenContainer$ = this._getCustomerTokenContainer.asObservable();

  public _workflowContainer = new Subject<any>();
  public workflowContainer$ = this._workflowContainer.asObservable();

  public _deleteWorkflowContainer = new Subject<any>();
  public deleteWorkflowContainer$ = this._deleteWorkflowContainer.asObservable();

  public _listWorkflowContainer = new Subject<any>();
  public listWorkflowContainer$ = this._listWorkflowContainer.asObservable();

  public _createTeamAccountContainer = new Subject<any>();
  public createTeamAccountContainer$ = this._createTeamAccountContainer.asObservable();

  public _setContentSchemaContainer = new Subject<any>();
  public setContentSchemaContainer$ = this._setContentSchemaContainer.asObservable();

  public _setContentContainer = new Subject<any>();
  public setContentContainer$ = this._setContentContainer.asObservable();

  public _setContentResponseContainer = new Subject<any>();
  public setContentResponseContainer$ = this._setContentResponseContainer.asObservable();

  public _getContentSchemaContainer = new Subject<any>();
  public getContentSchemaContainer$ = this._getContentSchemaContainer.asObservable();

  public _getSetContentSchemaContainer = new Subject<any>();
  public getSetContentSchemaContainer$ = this._getSetContentSchemaContainer.asObservable();

  public _getContentContainer = new Subject<any>();
  public getContentContainer$ = this._getContentContainer.asObservable();

  public _getContentResponseContainer = new Subject<any>();
  public getContentResponseContainer$ = this._getContentResponseContainer.asObservable();

  public _deleteContentSchemaContainer = new Subject<any>();
  public deleteContentSchemaContainer$ = this._deleteContentSchemaContainer.asObservable();

  public _deleteContentSchemaResponseContainer = new Subject<any>();
  public deleteContentSchemaResponseContainer$ = this._deleteContentSchemaResponseContainer.asObservable();

  public _deleteContentContainer = new Subject<any>();
  public deleteContentContainer$ = this._deleteContentContainer.asObservable();

  public _deleteContentResponseContainer = new Subject<any>();
  public deleteContentResponseContainer$ = this._deleteContentResponseContainer.asObservable();

  public _listContentSchemaContainer = new Subject<any>();
  public listContentSchemaContainer$ = this._listContentSchemaContainer.asObservable();

  public _listContentSchemaResponseContainer = new Subject<any>();
  public listContentSchemaResponseContainer$ = this._listContentSchemaResponseContainer.asObservable();

  public _listContentContainer = new Subject<any>();
  public listContentContainer$ = this._listContentContainer.asObservable();

  public _listContentResponseContainer = new Subject<any>();
  public listContentResponseContainer$ = this._listContentResponseContainer.asObservable();

  public _listTopicsContainer = new Subject<any>();
  public listTopicsContainer$ = this._listTopicsContainer.asObservable();

  public _deleteTopicContainer = new Subject<any>();
  public deleteTopicContainer$ = this._deleteTopicContainer.asObservable();

  public _topicContainer = new Subject<any>();
  public topicContainer$ = this._topicContainer.asObservable();

  public _listETemplatesContainer = new Subject<any>();
  public listETemplatesContainer$ = this._listETemplatesContainer.asObservable();

  public _listSMSTemplatesContainer = new Subject<any>();
  public listSMSTemplatesContainer$ = this._listSMSTemplatesContainer.asObservable();

  public _setSMSTemplateContainer = new Subject<any>();
  public setSMSTemplateContainer$ = this._setSMSTemplateContainer.asObservable();

  public _deleteSMSTemplateContainer = new Subject<any>();
  public deleteSMSTemplateContainer$ = this._deleteSMSTemplateContainer.asObservable();

  public _getReviewsContainer = new Subject<any>();
  public getReviewsContainer$ = this._getReviewsContainer.asObservable();

  public _setReviewStatusContainer = new Subject<any>();
  public setReviewStatusContainer$ = this._setReviewStatusContainer.asObservable();

  public _messageTemplateContainer = new Subject<any>();
  public messageTemplateContainer$ = this._messageTemplateContainer.asObservable();

  public _deleteMessageTemplateContainer = new Subject<any>();
  public deleteMessageTemplateContainer$ = this._deleteMessageTemplateContainer.asObservable();

  public _listMessageTemplatesContainer = new Subject<any>();
  public listMessageTemplatesContainer$ = this._listMessageTemplatesContainer.asObservable();

  public _deleteETemplateContainer = new Subject<any>();
  public deleteETemplateContainer$ = this._deleteETemplateContainer.asObservable();

  public _eTemplateContainer = new Subject<any>();
  public eTemplateContainer$ = this._eTemplateContainer.asObservable();

  public _listNotificationTemplatesContainer = new Subject<any>();
  public listNotificationTemplatesContainer$ = this._listNotificationTemplatesContainer.asObservable();

  public _listNotificationsContainer = new Subject<any>();
  public listNotificationsContainer$ = this._listNotificationsContainer.asObservable();

  public _deleteNotificationContainer = new Subject<any>();
  public deleteNotificationContainer$ = this._deleteNotificationContainer.asObservable();

  public _deleteNotificationTemplateContainer = new Subject<any>();
  public deleteNotificationTemplateContainer$ = this._deleteNotificationTemplateContainer.asObservable();

  public _notificationTemplateContainer = new Subject<any>();
  public notificationTemplateContainer$ = this._notificationTemplateContainer.asObservable();

  public _sendNotificationContainer = new Subject<any>();
  public sendNotificationContainer$ = this._sendNotificationContainer.asObservable();

  public _listAITemplatesContainer = new Subject<any>();
  public listAITemplatesContainer$ = this._listAITemplatesContainer.asObservable();

  public _listAppPermissionContainer = new Subject<any>();
  public listAppPermissionContainer$ = this._listAppPermissionContainer.asObservable();

  public _setAppPermissionContainer = new Subject<any>();
  public setAppPermissionContainer$ = this._setAppPermissionContainer.asObservable();

  public _deleteAppPermissionContainer = new Subject<any>();
  public deleteAppPermissionContainer$ = this._deleteAppPermissionContainer.asObservable();

  public _setTeamAccountContainer = new Subject<any>();
  public setTeamAccountContainer$ = this._createTeamAccountContainer.asObservable();

  public _getTeamAccountContainer = new Subject<any>();
  public getTeamAccountContainer$ = this._getTeamAccountContainer.asObservable();

  public _getTeamAccountResponseContainer = new Subject<any>();
  public getTeamAccountResponseContainer$ = this._getTeamAccountResponseContainer.asObservable();

  public _listTeamAccountContainer = new Subject<any>();
  public listTeamAccountContainer$ = this._listTeamAccountContainer.asObservable();

  public _deleteTeamAccountContainer = new Subject<any>();
  public deleteTeamAccountContainer$ = this._deleteTeamAccountContainer.asObservable();

  public _deleteTeamAccountResponseContainer = new Subject<any>();
  public deleteTeamAccountResponseContainer$ = this._deleteTeamAccountResponseContainer.asObservable();

  public _listAccountMenuContainer = new Subject<any>();
  public listAccountMenuContainer$ = this._listAccountMenuContainer.asObservable();

  public _getAccountMenuContainer = new Subject<any>();
  public getAccountMenuContainer$ = this._getAccountMenuContainer.asObservable();

  public _deleteAccountMenuContainer = new Subject<any>();
  public deleteAccountMenuContainer$ = this._deleteAccountMenuContainer.asObservable();

  public _messageAIModuleContainer = new Subject<any>();
  public messageAIModuleContainer$ = this._messageAIModuleContainer.asObservable();

  public _getAIModuleHistoryContainer = new Subject<any>();
  public getAIModuleHistoryContainer$ = this._getAIModuleHistoryContainer.asObservable();

  constructor(
    private router: Router,
    private mdw: MiddlwareService,
    private indexDBService: IndexDBService,
    private load: LoaderService,
    private es: EventService
  ) {}

  token: string;
  email: string;
  id: string;
  returnUrl: string;
  signupStatus: string;

  ngOnInit(): void {
    localStorage.setItem("auth", "false");
    localStorage.setItem("reconnect", "false");
    // this.indexDBService.connect();
  }
  //opens websocket if not open and responds based on server reply. Responds include functions for listing wireframes in database and deleting wireframes.
  sendRequest(data: any) {
    if (!this.ws || this.ws.readyState != WebSocket.OPEN) {
      this.ws = new WebSocket(this.url);
      // this.ws.onopen = (event: any) => console.log(event);
      this.ws.addEventListener("open", (evt: any) => {
        // console.log("open socket", this.ws);
        this.pinger();
        this.sendTheRequest(data);
      });
      this.ws.addEventListener("message", async (evt: any) => {
        clearInterval(this.pingInterval);
        this.pinger();
        // console.log(evt.data);
        let data = JSON.parse(evt.data);
        this._testContainer.next(data);
        switch (data.method) {
          case "TOKEN_AUTH_OK":
            this.load.isLoading.next(true);
            this.mdw._emailContainer.next(data.email);
            this.mdw._tokenContainer.next(data.token);
            this.mdw._idContainer.next(data.id);
            let app_id = localStorage.getItem("app_id");
            let id = localStorage.getItem("id");
            // let chat_id = localStorage.getItem("app_id");

            localStorage.setItem("email", data.email);
            localStorage.setItem("token", data.token);
            localStorage.setItem("id", data.id);
            localStorage.setItem("app_id", data.main_group_id);
            localStorage.setItem("name", data.name);
            localStorage.setItem("chat_id", data.chat_id);
            localStorage.setItem("vapp", data.is_nandbox === 1 ? "true" : "false");

            let updated_id = localStorage.getItem("id");
            this.indexDBService.connect(updated_id);
            this.signupStatus = data.signup_status;
            console.log("permission received", data.permission_level)

            this.mdw.setPermission(data.permission_level)

            this.mdw.savePermissions(data.id,data.permission_level )
            this.mdw.savePlan(data.id, data.plan_id)

            console.log ("plan level", plan_mapping[data.plan_id].level)

            this.mdw._planDetails.next(data);
            if (data.chat_id == null) {
              setTimeout(() => { this.processMethod(new GetUpgradedChatList(this.component_ref)); }, 2000);
            } else {
              this.processMethod(new SelectChat(data.chat_id, 0, this.component_ref));
            }
            localStorage.setItem("reconnect", "false");
            localStorage.removeItem("pass");
            this.verified = true;
            this._verifyContainer.next(true);

            if (data.id !=id || data.main_group_id !=app_id){
              localStorage.setItem("flush", "true")
            }

            console.log ("userId",localStorage.getItem("id"))
             this.mdw.setUserId(localStorage.getItem("id"));
            this.mdw.trackEvent('auth', {});
            this.mdw.setClarityUser(localStorage.getItem("id"), localStorage.getItem("app_id"), data.plan_id);




            break;

          case "QR_CODE":
            this._getQrcodeContainer.next(data);
            break;

          case "TOKEN":
            this.sendTheRequest(
              JSON.stringify({
                method: "TOKEN_AUTH",
                token: data.token,
                rem: true,
                version: 2,
              })
            );
            break;
          case "TOKEN_CHANGE":
            localStorage.setItem("token", data.token);
            this._tokenChangeContainer.next(true);
          break;

          case "chatList":
            if (data.chat_list.length > 0) {
              this._getChatListContainer.next(data);
              let main_group_id;
              let chat_found = false;

              if (
                localStorage.getItem("chat_id") == null ||
                localStorage.getItem("chat_id") == "undefined"
              ) {
                for (let i = 0; i < data.chat_list.length; i++) {
                  if (data.chat_list[i].is_default == 1) {
                    chat_found = true;
                    this.processMethod(
                      new SelectChat(
                        data.chat_list[i].id,
                        0,
                        this.component_ref
                      )
                    );
                    break;
                  }
                  if (data.chat_list[i].is_main == 1) {
                    main_group_id = data.chat_list[i].id;
                  }
                }
                if (!chat_found && main_group_id) {
                  this.processMethod(
                    new SelectChat(main_group_id, 0, this.component_ref)
                  );
                } else if (!chat_found) {
                  this.processMethod(
                    new SelectChat(data.chat_list[0].id, 0, this.component_ref)
                  );
                }
              }
            } else {
              this.router.navigate(["/hub/login"]);
            }
            break;
          case "chatSelected":
            localStorage.setItem("chat_id", data.chat_id);
            this._loginVerifyContainer.next(true);
            this._selectedChatContainer.next({id: data.chat_id, main_group_id: data.main_group_id});

            localStorage.setItem("auth", "true");
            const planDetails = this.mdw.getPlanDetails();
            const currentDate = new Date().getTime();

            let start = localStorage.getItem("start");
            if(start == "true"){
              this.signupStatus = "ai_init";
              this.processMethod(new SetSignupStatus("ai_init"));
              localStorage.removeItem("start");
            }

            console.log("signup Status", this.signupStatus)

            if (planDetails.expire && planDetails.expire < currentDate || planDetails.cancel_end && planDetails.cancel_end < currentDate ){
              this.router.navigate(["/billings/expire"]);
              this._expiredContainer.next(true);

            } else {
              if(data.main_group_id !== data.chat_id){
                this.router.navigate(["/message"]);
              } else
              // if (localStorage.getItem("start") == "true" && localStorage.getItem("template_id") == null){
              if (this.signupStatus == "ai_init" && localStorage.getItem("template_id") == null){
                this.router.navigate(["/appbuilder/ai"]);
                this.mdw.trackEvent('app_builder_start', {
                  signup_type: "ai"
                });

              } else if (localStorage.getItem("returnUrl")) {
                this.router.navigate([localStorage.getItem("returnUrl")]);

              } else {
                if(localStorage.getItem("template_id") != null && !this.isTabletView()){
                  setTimeout(() => { this.mdw._tourContainer.next(true); }, 3500);
                  this.router.navigate(["/appbuilder/navigation"]);
                  this.mdw.trackEvent('app_builder_start', {
                  signup_type: "template",
                  template_id: localStorage.getItem("template_id")
                });

                } else {
                  this.router.navigate(["/"]);
                }
              }
              if(planDetails.trial_end_date && planDetails.trial_end_date < currentDate){
              console.log ("websocket trial_end_date", planDetails.trial_end_date)
              this._endTrialContainer.next(true);
              }

            }
            break;
          case "listUsersResponse":
            this._listUsersContainer.next(data);
            break;
          case "getWhitelistUsersResponse":
            this._whiteListUsersContainer.next(data);
            break;
          case "getBlacklistUsersResponse":
            this._blackListUsersContainer.next(data);
            break;
          case "listChatsResponse":
            this._listChatsContainer.next(data);
            switch (data.type) {
              case "Channel":
                this._listChannelsContainer.next(data);
                break;
              case "Group":
                this._listgroupsContainer.next(data);
                break;
              case "BookingChannel":
                this._listbookingsContainer.next(data);
                break;
              case "EventChannel":
                this._listEventsContainer.next(data);
                break;
            }
            break;
          case "chatInvalid":
            this._chatInvalidContainer.next(data);
            break;
          case "chatDetails":
            this._chatDetailsContainer.next(data);
            break;
          case "groupDeleted":
            this._groupDeletedContainer.next(data);
            break;
          case "bookingExceptions":
            this._bookingExceptionsContainer.next(data);
            break;
          case "bookingPeriods":
            this._bookingPeriodsContainer.next(data);
            break;
          case "listChatTagsResponse":
            this._listChatTagsContainer.next(data);
            break;
          case "chatTags":
            this._chatTagsContainer.next(data);
            break;
          case "getMsgListResponse":
            // console.log(data);
            this._messageListResponeContainer.next(data);
            break;
          case "getMsgListLevel1Response":
            this._messageListLevel1ResponeContainer.next(data);
            break;
          case "message":
            this._messageTagsContainer.next(data);
            break;
          case "listStoreResponse":
            this._listStoreContainer.next(data);
            break;
          case "listProductItemResponse":
            this._listProductContainer.next(data);
            break;
          case "listCollectionItemResponse":
            this._listCollectionContainer.next(data);
            break;
          case "listPaymentOrdersResponse":
            this._listPaymentOrdersContainer.next(data);
            break;

          case "listUserCouponsResponse":
            this._listCouponsContainer.next(data);
            break;
          case "listCampaignList":
            this._listCampaignsContainer.next(data);
            break;
          case "listMenusResponse":
            this._listPollsContainer.next(data);
            break;
          case "profileResponse":
            this._getProfileContainer.next(data);
            break;
          case "setMenuPageResponse":
            this._menuPageResponseContainer.next(data);
            break;
          case "listAccountMenuResponse":
            this._listAccountMenuContainer.next(data);
            break;
          case "getAccountMenuResponse":
            this._getAccountMenuContainer.next(data);
            break;
          case "deleteAccountMenuResponse":
            this._deleteAccountMenuContainer.next(data);
            break;
          case "myGallery":
            this._myGalleryContainer.next(data);
            break;
          case "deleteMyGallery_ack":
            this._deleteMyGalleryContainer.next(data);
            break;
          case "myProfileResponse":
            if (this.component_ref === data.ref) {
              this.mdw._profileContainer.next(data.data);
            }

            this._getMyProfileContainer.next(data);

            if (data.data.role == 1 || data.data.role == 2) {
              this.mdw._showAdminContainer.next(true);
            } else {
              // console.log("admin false");
              this.mdw._showAdminContainer.next(false);
            }
            if (data.data.role == 2) {
              this.mdw._showRootAdminContainer.next(true);
            } else {
              this.mdw._showRootAdminContainer.next(false);
            }
            break;

          case "myDomainsResponse":
            this._myDomainsContainer.next(data);
            break;
          case "listMyExchangeDomainsResponse":
            this._listMyExchangeDomainsContainer.next(data);
            break;
          case "getMyDomainResponse":
            this._getMyDomainContainer.next(data);
            break;
          case "getDomainResponse":
            this._getDomainContainer.next(data);
            break;
          case "searchDomainsResponse":
            this._searchDomainsContainer.next(data);
            break;
          case "calendar":
            this._calendarContainer.next(data);
            break;
          case "listCalendarsResponse":
            this._listCalendarsContainer.next(data);
            break;
          case "calendarDetails":
            this._calendarDetailsContainer.next(data);
            break;
          case "getStoreResponse":
            this._getStoreContainer.next(data);
            break;

          case "getOrderResponse":
            this._getOrderContainer.next(data);
            break;
          case "myOrdersResponse":
            this._myOrdersContainer.next(data);
            break;
          case "getOtherServiceResponse":
            this._getOtherServiceContainer.next(data);
            break;

          case "getChatResponse":
            this._getChatContainer.next(data);
            break;
          case "message":
            this._getMessageContainer.next(data);
            break;
          case "appConfig":
            this._appBuilderContainer.next(data);
            this._chatWithAIContainer.next(data);
            break;
          case "getSignupPatternResponse":
            this._getSignupPatternContainer.next(data);
            break;
          case "getMyMediaResponse":
            this._getMyMediaResponseContainer.next(data);
            break;
          case "bots":
            this._listBotsResponseContainer.next(data);
            break;
          case "getMyBotResponse":
            this._getMyBotResponseContainer.next(data);
            break;
          case "appReleases":
            this._appReleasesContainer.next(data);
            break;
          case "appRelease":
            this._getAppReleaseContainer.next(data);
            break;
          case "apps":
            this._getAppsContainer.next(data);
            break;
          case "appStore":
            this._getAppStoreContainer.next(data);
            break;
          case "appsSetup":
            this._getAppsSetupContainer.next(data);
            break;
          case "accountOnlineResponse":
            this._otherAccountOnlineContainer.next(data);
            break;
          case "requestAppleCode":
            this._requestAppleCodeContainer.next(data);
            break;
          case "appSetup":
            this._appSetupContainer.next(data);
            break;
          case "setAppConfigResponse":
            this._setAppConfigResponseContainer.next(data);
            break;
          case "publishAppConfigResponse":
            this._publishAppConfigResponseContainer.next(data);
            break;
          case "senderVerifyResponse":
            this._senderVerifyServiceContainer.next(data);
            break;
          case "receiverVerifyResponse":
            this._receiverVerifyServiceContainer.next(data);
            break;
          case "highlightResponse":
            this._highlightContainer.next(data);
            break;

          case "rechargeResponse":
            this._rechargeContainer.next(data);
            break;
          case "createPaymentResponse":
            this._createPaymentContainer.next(data);
            break;
          case "getBalanceResponse":
            this._getBalanceContainer.next(data);
            break;
          case "getPaymentFeesResponse":
            this._paymentFeesContainer.next(data);
            break;
          case "payoutResponse":
            this._payoutContainer.next(data);
            break;
          case "getBillingHistoryResponse":
            this._billingHistoryContainer.next(data);
            break;
          case "setProductItemResponse":
            this._setProductItemContainer.next(data);
            break;
          case "getProductItemResponse":
            this._getProductItemContainer.next(data);
            break;
          case "stock":
            this._getStockContainer.next(data);
            break;
          case "setProductItemArrayResponse":
            this._setProductItemArrayContainer.next(data);
            break;
          case "setCollectionItemResponse":
            this._setCollectionItemContainer.next(data);
            break;
          case "getCollectionItemResponse":
            this._getCollectionItemContainer.next(data);
            break;
          case "setCollectionProductResponse":
            this._setCollectionProductContainer.next(data);
            break;
          case "createArticle_ack":
            this._createArticleACKContainer.next(data);
            break;
          case "setUserCouponResponse":
            this._setUserCouponContainer.next(data);
            break;
          case "userDetails":
            this._getUserContainer.next(data);
            break;
          case "myMemberChats":
            this._getMyMemberChatsContainer.next(data);
            break;
          case "chatMember":
            this._addChatMemberContainer.next(data);
            break;
          case "likeMessage_ack":
            this._likeMessageAckContainer.next(data);
            break;
          case "chatCounters":
            this._chatCountersContainer.next(data);
            break;
          case "getListChatTagsResponse":
            this._getListChatTagsContainer.next(data);
            break;
          case "verificationTemplate":
            this._verificationTemplateContainer.next(data);
            break;
          case "smtpConfig":
            this._smtpConfigContainer.next(data);
            break;
          case "messagingVendor":
            this._messagingVendorContainer.next(data);
            break;
          case "signedUpDemoAccount":
            this._signedUpDemoAccountContainer.next(data);
            break;
          case "registeredDemoAccount":
            this._registeredDemoAccountContainer.next(data);
            break;
          case "testedMessagingVendor":
            this._testedMessagingVendorContainer.next(data);
            break;
          case "thirdPartyInfo":
            this._thirdPartyInfoContainer.next(data);
            break;
          case "paymentProviders":
            this._paymentProvidersContainer.next(data);
            break;
          case "adsProviders":
            this._adsProvidersContainer.next(data);
            break;
          case "getPaymentInfoResponse":
            this._getPaymentInfoContainer.next(data);
            break;
          case "getUpdatedPaymentInfoResponse":
            this._getUpdatedPaymentInfoContainer.next(data);
            break;
          case "getInvoicesResponse":
            this._getInvoicesContainer.next(data);
            break;
          case "retrieveCouponResponse":
            this._retrieveCouponContainer.next(data);
            break;
          case "createCardResponse":
            this._createCardContainer.next(data);
            break;
          case "setDefaultCardResponse":
            this._setDefaultCardContainer.next(data);
            break;
          case "deleteCardResponse":
            this._deleteCardContainer.next(data);
            break;
          case "subscribeToAddonsResponse":
            this._subscribeToAddonsCouponContainer.next(data);
            break;
          case "changePlanResponse":
            this._changePlanContainer.next(data);
            break;
          case "subscribeToPlanResponse":
            this._subscribeToPlanContainer.next(data);
            break;
          case "cancelStripeSubscriptionResponse":
            this._cancelStripeSubscriptionContainer.next(data);
            break;
          case "revokeSubscriptionResponse":
            this._revokeSubscriptionContainer.next(data);
            break;
          case "deleteSignupPatternResponse":
            this._deleteSignupPatternContainer.next(data);
            break;
          case "setSignupPatternResponse":
            this._setSignupPatternContainer.next(data);
            break;
          case "addToWhitelist_ack":
            this._addWhitelistAckContainer.next(data);
            break;
          case "addToBlacklist_ack":
            this._addBlacklistAckContainer.next(data);
            break;
          case "blacklist":
            this._blacklistContainer.next(data);
            break;
          case "removeFromWhitelist_ack":
            this._deleteWhitelistAckContainer.next(data);
            break;
          case "removeFromBlacklist_ack":
            this._deleteBlacklistAckContainer.next(data);
            break;
          case "appChannelSettings":
            this._appChannelSettingsContainer.next(data);
            break;
          case "updateAppInfoResponse":
            this._updateAppInfoContainer.next(data);
            break;
          case "botToken":
            this._botTokenContainer.next(data);
            break;
          case "getChatWithAIResponse":
            this._chatWithAIListContainer.next(data);
            break;
          case "resetAIChatResponse":
            this._resetChatWithAIContainer.next(data);
            break;
          case "getUserListResponse":
            this._getUserListContainer.next(data);
            break;
          case "bot":
            this._botResponceContainer.next(data);
            break;
          case "botPublished":
            this._botPublishedContainer.next(data);
            break;
          case "paymentbot":
            this._publishBotContainer.next(data);
            break;
          case "deleteProductElementResponse":
            this._deleteProductElementContainer.next(data);
            break;
          case "cancelMessageSchedule_ack":
            this._cancelMessageScheduleContainer.next(data);
            break;
          case "setTaxResponse":
            this._setTaxContainer.next(data);
            break;
          case "setFeeResponse":
          this._setFeeContainer.next(data);
          break;

          case "setAppInfoResponse":
          this._setAppInfoContainer.next(data);
          break;

          case "getTaxResponse":
          this._getTaxContainer.next(data);
          break;

          case "getFeeResponse":
          this._getFeeContainer.next(data);
          break;

          case "getAppInfoResponse":
            this._getAppInfoContainer.next(data);
            break;

          case "getShippingResponse":
            this._getShippingContainer.next(data);
            break;

          case "setShippingResponse":
            this._setShippingContainer.next(data);
            break;

          case "botTemplates":
            this._botTemplatesContainer.next(data);
            break;


          case "chatAdministrators":
            this._getChatAdministratorsContainer.next(data);
            break;

          case "listPollResponse":
            this._listPollContainer.next(data);
            break;
          case "listGeoLocationResponse":
            this._listGeoLocationContainer.next(data);
            break;
          case "setGeoLocationResponse":
            this._setGeoLocationContainer.next(data);
            break;
          case "getGeoLocationResponse":
            this._getGeoLocationContainer.next(data);
            break;
          case "poll":
            this._pollContainer.next(data);
            break;
          case "deletePollResponse":
            this._deletePollContainer.next(data);
            break;
          case "deleteStoreResponse":
            this._deleteStoreContainer.next(data);
            break;
          case "deleteCollectionElementResponse":
            this._deleteCollectionContainer.next(data);
            break;
          case "setStoreResponse":
            this._setStoreContainer.next(data);
            break;
          case "template":
            this._setAppConfigTemplateContainer.next(data);
            break;
          case "manageAppMemberResponse":
            this._manageAppMemberContainer.next(data);
            break;
          case "deleteAppMemberResponse":
            this._deleteAppMemberContainer.next(data);
            break;
          case "deleteCouponResponse":
            this._deleteCouponResponseContainer.next(data);
            break;
          case "removeCalendarResponse":
            this._removeCalendarResponseContainer.next(data);
            break;
          case "mapMarkers":
            this._getMapMarkersResponseContainer.next(data);
            break;
          case "mapMarker":
            this._mapMarkerResponseContainer.next(data);
            break;
          case "getUsersPaymentOrdersResponse":
            this._getUsersPaymentOrdersContainer.next(data);
            break;
          case "listOrderRequestResponse":
            this._getOrderRequestContainer.next(data);
            break;
          case "getOrderRequestResponse":
            this._getOrderRequestDetailsContainer.next(data);
            break;
          case "listOfferResponse":
            this._listOffersContainer.next(data);
            break;
          case "getOrderDetailsResponse":
            this._getOrderDetailsContainer.next(data);
            break;
          case "responseAI":
            this._responseAIContainer.next(data);
            break;
          case "getAIHistoryResponse":
            this._getAIHistoryContainer.next(data);
            break;
          case "clearAIHistoryResponse":
            this._clearAIHistoryContainer.next(data);
            break;
          case "getAIDefinitionResponse":
            this._getAIDefinitionContainer.next(data);
            break;
          case "updateAIDefinitionResponse":
            this._updateAIDefinitionContainer.next(data);
            break;
          case "getPollResultResponse":
            this._getPollResultContainer.next(data);
            break;
          case "publishPollResultResponse":
            this._publishPollResultContainer.next(data);
            break;
          case "genStates":
            this._genStatesContainer.next(data);
            break;
          case "searchItemsResponse":
            this._searchItemsContainer.next(data);
            break;
          case "tags":
            this._getTagsValueContainer.next(data);
            break;
          case "listPartnersResponse":
            this._listPartnersContainer.next(data);
            break;

          case "listAppFunnelResponse":
            this._listAppFunnelContainer.next(data);
            break;

          case "listAppPaymentsResponse":
            this._listAppPaymentsContainer.next(data);
            break;

          case "listAppRevenueSummaryResponse":
            this._listAppRevenueSummaryContainer.next(data);
            break;

          case "listFunnelMetricsResponse":
            this._listFunnelMetricsContainer.next(data);
            break;

          case "listPaymentMetricsResponse":
            this._listPaymentMetricsContainer.next(data);
            break;

          case "listPaymentRetentionSummaryResponse":
            this._listPaymentRetentionSummaryContainer.next(data);
            break;

          case "listRevenueKpiSummaryResponse":
            this._listRevenueKpiSummaryContainer.next(data);
            break;

          case "listSignupConversionCohortsResponse":
            this._listSignupConversionCohortsContainer.next(data);
            break;

          case "listSignupSourceMetricsResponse":
            this._listSignupSourceMetricsContainer.next(data);
            break;
          case "listSubscriptionMetricsResponse":
            this._listSubscriptionMetricsContainer.next(data);
            break;
          case "listFunnelKpiSummaryResponse":
            this._listFunnelKpiSummaryContainer.next(data);
            break;

          case "getCustomerTokenResponse":
            this._getCustomerTokenContainer.next(data);
            break;

          case "workflow":
            this._workflowContainer.next(data);
            break;
          case "deleteWorkflowResponse":
            this._deleteWorkflowContainer.next(data);
            break;
          case "listWorkflowResponse":
            this._listWorkflowContainer.next(data);
            break;

          case "setAppBuildRateResponse":
            this._setAppBuildRateContainer.next(data);
            break;

          case "setAppPaymentDateResponse":
            this._setAppPaymentDateContainer.next(data);
            break;

          case "sendDeviceCalendarResponse":
            this._sendDeviceCalendarContainer.next(data);
            break;

          case "createTeamAccountResponse":
            this._createTeamAccountContainer.next(data);
            break;

          case "setTeamAccountResponse":
           this._setTeamAccountContainer.next(data);
           break;
          case "setCustomSchemaResponse":
            this._setContentSchemaContainer.next(data);
            break;
          case "setContent":
            this._setContentContainer.next(data);
            break;
          case "setContentResponse":
            this._setContentResponseContainer.next(data);
            break;
          case "getContentSchema":
            this._getContentSchemaContainer.next(data);
            break;
          case "getCustomSchemaResponse":
            this._getSetContentSchemaContainer.next(data);
            break;
          case "getContent":
            this._getContentContainer.next(data);
            break;
          case "getContentResponse":
            this._getContentResponseContainer.next(data);
            break;
          case "deleteCustomSchema":
            this._deleteContentSchemaContainer.next(data);
            break;
          case "deleteContentSchemaResponse":
            this._deleteContentSchemaResponseContainer.next(data);
            break;
          case "deleteContent":
            this._deleteContentContainer.next(data);
            break;
          case "deleteContentResponse":
            this._deleteContentResponseContainer.next(data);
            break;
          case "listContentSchema":
            this._listContentSchemaContainer.next(data);
            break;
          case "listCustomSchemaResponse":
            this._listContentSchemaResponseContainer.next(data);
            break;
          case "listContent":
            this._listContentContainer.next(data);
            break;
          case "listContentResponse":
            this._listContentResponseContainer.next(data);
            break;

          case "listTopicsResponse":
            this._listTopicsContainer.next(data);
            break;
          case "deleteTopicResponse":
            this._deleteTopicContainer.next(data);
            break;
          case "topic":
            this._topicContainer.next(data);
            break;

          case "listAppPermission":
            this._listAppPermissionContainer.next(data);
            break;

          case "setAppPermission":
            this._setAppPermissionContainer.next(data);
           break;

          case "deleteAppPermission":
            this._deleteAppPermissionContainer.next(data);
            break;

          case "getTeamAccount":
            this._getTeamAccountContainer.next(data);
            break;

          case "getTeamAccountResponse":
            this._getTeamAccountResponseContainer.next(data);
            break;

          case "listTeamAccount":
            this._listTeamAccountContainer.next(data);
            break;

          case "deleteTeamAccount":
            this._deleteTeamAccountContainer.next(data);
            break;

          case "deleteTeamAccountResponse":
            this._deleteTeamAccountResponseContainer.next(data);
            break;

          case "listAppPermission":
            this._listAppPermissionContainer.next(data);
            break;

          case "setAppPermission":
            this._setAppPermissionContainer.next(data);
           break;

          case "deleteAppPermission":
            this._deleteAppPermissionContainer.next(data);
            break;

          case "getTeamAccount":
            this._getTeamAccountContainer.next(data);
            break;

          case "getTeamAccountResponse":
            this._getTeamAccountResponseContainer.next(data);
            break;

          case "listTeamAccount":
            this._listTeamAccountContainer.next(data);
            break;

          case "deleteTeamAccount":
            this._deleteTeamAccountContainer.next(data);
            break;

          case "deleteTeamAccountResponse":
            this._deleteTeamAccountResponseContainer.next(data);
            break;

          case "listETemplatesResponse":
            this._listETemplatesContainer.next(data);
            break;
          case "deleteETemplateResponse":
            this._deleteETemplateContainer.next(data);
            break;
          case "eTemplate":
            this._eTemplateContainer.next(data);
            break;

          case "listNotificationTemplatesResponse":
            this._listNotificationTemplatesContainer.next(data);
            break;
          case "listNotificationsResponse":
            this._listNotificationsContainer.next(data);
            break;
          case "deleteNotificationTemplateResponse":
            this._deleteNotificationTemplateContainer.next(data);
            break;
          case "deleteNotificationResponse":
            this._deleteNotificationContainer.next(data);
            break;
          case "notificationTemplate":
            this._notificationTemplateContainer.next(data);
            break;
          case "sendNotificationResponse":
            this._sendNotificationContainer.next(data);
            break;
          case "listAITemplatesResponse":
            this._listAITemplatesContainer.next(data);
            break;
          case "myProfile":
            this._myProfileContainer.next(data);
            break;
          case "setCatalogResponse":
            this._setCatalogContainer.next(data);
            break;
          case "getCatalogResponse":
            this._getCatalogContainer.next(data);
            break;
          case "listCatalogResponse":
            this._listCatalogContainer.next(data);
            break;
          case "deleteCatalogResponse":
            this._deleteCatalogContainer.next(data);
            break;
          case "messageAIModuleResponse":
            this._messageAIModuleContainer.next(data);
            break;
          case "getAIModuleHistoryResponse":
            this._getAIModuleHistoryContainer.next(data);
            break;
          case "maintenanceResponse":
            this._maintenanceContainer.next(data);
            break;

          case "sendEmailResponse":
            this._sendEmailContainer.next(data);
            break;
          case "listEmailsResponse":
            this._listEmailsContainer.next(data);
            break;
          case "deleteEmailsFromHistoryResponse":
            this._deleteEmailsFromHistoryContainer.next(data);
            break;
          case "getEmailDetailsResponse":
            this._emailDetailsContainer.next(data);
            break;
          case "sendSmsResponse":
            this._sendSmsContainer.next(data);
            break;
          case "listSmsResponse":
            this._listSmsContainer.next(data);
            break;
          case "deleteSmsFromHistoryResponse":
            this._deleteSmsFromHistoryContainer.next(data);
            break;
          case "getSmsDetailsResponse":
            this._smsDetailsContainer.next(data);
            break;
          case "listRequestsToCheckResponse":
            this._listRequestsToCheckContainer.next(data);
            break;
          case "processMakerCheckerRecord":
            this._checkUserRequestContainer.next(data);
            break;
          case "listSMSTemplatesResponse":
            this._listSMSTemplatesContainer.next(data);
            break;
          case "smsTemplate":
            this._setSMSTemplateContainer.next(data);
            break;
          case "deleteSMSTemplateResponse":
            this._deleteSMSTemplateContainer.next(data);
            break;
          case "getReviewsResponse":
            this._getReviewsContainer.next(data);
            break;
          case "setReviewStatusResponse":
            this._setReviewStatusContainer.next(data);
            break;
          case "messageTemplate":
            this._messageTemplateContainer.next(data);
            break;
          case "deleteMessageTemplateResponse":
            this._deleteMessageTemplateContainer.next(data);
            break;
          case "listMessageTemplatesResponse":
            this._listMessageTemplatesContainer.next(data);
            break;
          case "mediaFile":
            this._mediaFileContainer.next(data);
            break;
          case "getArticleResponse":
            this._getArticleContainer.next(data);
            break;
          case "listBranchResponse":
            this._listBranchContainer.next(data);
            break;
          case "setBranchResponse":
            this._setBranchContainer.next(data);
            break;
          case "getBranchResponse":
            this._getBranchContainer.next(data);
            break;
          case "setBranchUserResponse":
            this._setBranchUserContainer.next(data);
            break;
          case "removeBranchUserResponse":
            this._removeBranchUserContainer.next(data);
            break;
          case "listBranchUserResponse":
            this._listBranchUserContainer.next(data);
            break;

          case "listVendorsResponse":
            this._listVendorsContainer.next(data);
            break;
          case "setVendorResponse":
            this._setVendorContainer.next(data);
            break;
          case "getVendorResponse":
            this._getVendorContainer.next(data);
            break;
          case "deleteVendorResponse":
            this._deleteVendorContainer.next(data);
            break;
          case "deleteGeoLocationResponse":
            this._deleteGeoLocationContainer.next(data);
            break;
          case "deleteBranchResponse":
            this._deleteBranchContainer.next(data);
            break;
          case "listZonesResponse":
            this._listZonesContainer.next(data);
            break;
          case "setZoneResponse":
            this._setZoneContainer.next(data);
            break;
          case "getZoneResponse":
            this._getZoneContainer.next(data);
            break;
          case "getZoneResponse":
            this._getZoneContainer.next(data);
            break;
          case "deleteZoneResponse":
            this._deleteZoneContainer.next(data);
            break;
          case "setCategoryResponse":
            this._setCategoryContainer.next(data);
            break;
          case "getCategoryResponse":
            this._getCategoryContainer.next(data);
            break;
          case "listCategoryResponse":
            this._listCategoryContainer.next(data);
            break;
          case "deleteCategoryResponse":
            this._deleteCategoryContainer.next(data);
            break;
          case "processMakerCheckerRecordResponse":
            this._processMakerCheckerRecordContainer.next(data);
            break;
          case "error":
            this.errorMessage(data);
            break;

          case "PONG":
            // console.log("PONG");
            break;

          default:
            if (data.error) {
               this.errorMessage(data.error)

              if ( data.error && data.error < 200000 && data.error >= 100000 && data.error != 100099 &&     data.error != 199990 &&   data.error != 199992 &&   data.error != 199999 && data.error !=160015) {
                if(localStorage.getItem("reconnect") && localStorage.getItem("reconnect") == "false"){
                  this.reconnect(3);
                }
              } else if (data.error == 199992) {
                setTimeout(async () => {
                  this.logoutMultipleSessions();
                }, 2000);
              } else if (data.error == 100099){
                setTimeout(async () => {
                  this.logout();
                }, 2000);
              } else {
                this.handleServerError(data);

              }
            }
            break;
        }
      });

      this.ws.addEventListener("close", async (event: any) => {
        // console.log("websocket close");
        // console.log(event);

        this.verified = false;
        this._verifyContainer.next(false);
        clearInterval(this.pingInterval);

        switch (event.code) {
          case 4000:
          case 4003:
            // this.reconnect(3);
          break;


          // case 1000:
          // case 1005:
          case 1006:
            if(localStorage.getItem("reconnect") == "false"){
              await this.sleep(4000);
              this.reconnect(5);
            }
          break;

          case 4001:
          case 4002:
          case 4004:
            localStorage.removeItem("id");
            localStorage.removeItem("email");
            localStorage.removeItem("token");
            localStorage.removeItem("returnUrl");
            this.mdw.clear();
            this.resetColors();
            localStorage.setItem("auth", "false");
            localStorage.setItem("reconnect", "false");
            this.router.navigate(["/hub/login"]);
            this.mdw.clearUserId();
          break;
          case 4999:
            this.mdw.clear();
            this.resetColors();
            localStorage.setItem("auth", "false");
            localStorage.setItem("reconnect", "false");
            this.router.navigate(["/hub/login"]);
          break;
        }
      });
      this.ws.addEventListener("error", (event: any) => {});
    }
  }

  //sends request to websocket
  sendTheRequest(this: any, data: string) {
    // console.log("sending request " + data);
    if (!this.ws || this.ws.readyState != WebSocket.OPEN) {
      throw "WebSocket not open";
    }

    this.ws.send(data);
    clearInterval(this.pingInterval);
    this.pinger();
  }

  pinger() {
    this.pingInterval = setInterval(() => {
      this.ws.send(JSON.stringify({ method: "PING" }));
    }, 25000);
  }

  async reconnect(retry: number) {
    console.log("RECONNECTING 1");
    let connected = false;
    let token = localStorage.getItem("token");
    let id = localStorage.getItem("id");
    let email = localStorage.getItem("email");

    if (token && email && id) {
      console.log("RECONNECTING 2");
      this._reconnectNoticeContainer.next("REconnecting");
      localStorage.setItem("reconnect", "true");
      for (let i = 0; i < retry; i++) {
        // await this.reconnectWebsocket(token, id, email);
        if (token != null && email != null && id != null) {
          this.sendRequest(JSON.stringify({
              method: "TOKEN_AUTH",
              token: token,
              id: id,
              email: email,
              rem: true,
              verion: 2,
            })
          );
        } else {
          break;
        }
        await this.sleep(5000);
        // console.log("Check Verification");
        // console.log(this.verified);
        if (this.verified) {
          console.log("CONECTED");
          this._reconnectNoticeContainer.next("CONNECTED");
          connected = true;
          this._refreshSuccessContainer.next(true);
          break;
        }
      }
      if (!connected) {
        this._reconnectNoticeContainer.next("DISconnected 1");
        localStorage.removeItem("id");
        localStorage.removeItem("email");
        localStorage.removeItem("token");
        localStorage.removeItem("returnUrl");
        localStorage.setItem("reconnect", "false");
        this.mdw.clearUserId();
        this.mdw.clear();
        this.resetColors();
        localStorage.setItem("auth", "false");
        this.ws.close();
        this.router.navigate(["/hub/login"]);
      }
    } else {
      this._reconnectNoticeContainer.next("DISconnected 2");
      localStorage.removeItem("id");
      localStorage.removeItem("email");
      localStorage.removeItem("token");
      localStorage.removeItem("returnUrl");
      localStorage.setItem("reconnect", "false");
      this.mdw.clearUserId();
      this.mdw.clear();
      this.resetColors();
      localStorage.setItem("auth", "false");
      // this.router.navigate(["/hub/login"]);
    }
  }

  processMethod(data: any) {
    switch (data.method) {
      case "getUpgradedChatList":
      case "selectChat":
      case "listUsers":
      case "getWhitelistUsers":
      case "getBlacklistUsers":
      case "listChats":
      case "listChatTags":
      case "getChatTags":
      case "addChatTag":
      case "createChat":
      case "setChat":
      case "getChat":
      case "deleteGroup":
      case "getChatList":
      case "getMsgList":
      case "getMsgListLevel1":
      case "getMsgMax":
      case "getBookingExceptions":
      case "sendMessage":
      case "sendPhoto":
      case "sendVideo":
      case "sendAudio":
      case "sendDocument":
      case "listUserCoupons":
      case "listMenus":
      case "listAccountMenu":
      case "getAccountMenu":
      case "changeStatusAccountMenu":
      case "createMyPage":
      case "setMyPage":
      case "publishAppConfig":
      case "setMenuPage":
      case "getMenuPage":
      case "setAppConfig":
      case "listAppRelease":
      case "getApps":
      case "generateApp":
      case "getAppRelease":
      case "getAppStore":
      case "getAppsSetup":
      case "setupApp":
      case "setAppStore":
      case "setAppleCode":
      case "revoke":
      case "getMyMedia":
      case "setBookingPeriods":
      case "getBookingPeriods":
      case "setProviderConfig":
      case "getProviderConfig":
      case "createApiToken":
      case "getApiToken":
      case "setBookingExceptions":
      case "removeBookingPeriods":
      case "listBots":
      case "listCalendars":
      case "createCalendar":
      case "getCalendar":
      case "getCalendarDetails":
      case "setCalendar":
      case "setCalendarDetail":
      case "setProductItem":
      case "getProductItem":
      case "setProductItemArray":
      case "setProductToCollections":
      case "getStock":
      case "setStock":
      case "setCollectionItem":
      case "getCollectionItem":
      case "setCollectionProduct":
      case "getCollectionProduct":
      case "setUserCoupon":
      case "addChatMember":
      case "addChatAdmin":
      case "demoteAdmin":
      case "getListChatTags":
      case "getVerificationTemplate":
      case "setVerificationTemplate":
      case "clearVerificationTemplate":
      case "getSmtp":
      case "setSmtp":
      case "getMessagingVendor":
      case "setThirdPartyInfo":
      case "signUpDemoAccount":
      case "registerDemoAccount":
      case "testMessagingVendor":
      case "setPaymentProvider":
      case "getPaymentProviders":
      case "getTacDemoAccount":
      case "getAdsProviders":
      case "setAdsProvider":
      case "getPaymentInfo":
      case "getInvoices":
      case "subscribeToPlan":
      case "retrieveCoupon":
      case "createCard":
      case "setDefaultCard":
      case "deleteCard":
      case "subscribeToAddons":
      case "changePlan":
      case "cancelStripeSubscription":
      case "revokeSubscription":
      case "sendCalendar":
      case "banChatMember":
      case "removeChatMember":
      case "promoteChatMember":
      case "setRole":
      case "unbanChatMember":
      case "likeMessage":
      case "getChatCounters":
      case "getWhitelist":
      case "setSignupPattern":
      case "getSignupPattern":
      case "addToWhitelist":
      case "addToBlacklist":
      case "deleteSignupPattern":
      case "removeFromWhitelist":
      case "removeFromBlacklist":
      case "getAppChannelSettings":
      case "setAppChannelSettings":
      case "updateAppInfo":
      case "getMyBots":
      case "getMyBot":
      case "removeBot":
      case "getBotToken":
      case "createBot":
      case "getUserList":
      case "setBot":
      case "publishBot":
      case "getChatMember":
      case "setPrivileges":
      case "deleteProductElement":
      case "cancelMessageSchedule":
      case "setTax":
      case "getTax":
      case "setFee":
      case "getFee":
      case "setAppInfo":
      case "getAppInfo":
      case "setShipping":
      case "getShipping":
      case "getBotTemplates":
      case "addBot":
      case "setStore":
      case "getStore":
      case "getChatAdministrators":
      case "getAppConfigHistory":
      case "removeAppRelease":
      case "listPoll":
      case "setPoll":
      case "getPoll":
      case "deletePoll":
      case "deleteStore":
      case "deleteCollectionElement":
      case "getMyCallbackStats":

      case "listStore":
      case "listProductItem":
      case "listCollectionItem":
      case "recallMessage":

      case "setProfile":
      case "getMyProfile":
      case "getProfile":
      case "getUser":
      case "getMyMemberChats":
      case "setChatMemberTags":

      case "getMyGallery":
      case "deleteMyGallery":

      case "setDomain":
      case "updateDomain":
      case "getDomain":
      case "getMyDomain":
      case "getDomainListing":
      case "myDomains":
      case "listMyExchangeDomains":
      case "searchDomains":

      case "requestOrder":
      case "getOrder":
      case "getOtherService":
      case "myOrders":
      case "updateOrderService":
      case "approveOrder":
      case "approveOrderExchange":

      case "accountOnline":
      case "message":
      case "getChat":

      case "chatWithAI":

      case "senderVerify":
      case "receiverVerify":
      case "highlight":
      case "listPaymentOrders":

      case "recharge":
      case "createPayment":
      case "getBalance":
      case "getPaymentFees":
      case "payout":
      case "getBillingHistory":
      case "updatePayout":
      case "getCampaignList":
      case "getAppConfig":

      case "adminUpdateOrder":
      case "adminTransfer":

      case "setTemplateFunction":
      case "setAppConfigTemplate":
      case "setTemplateMessage":
      case "getTemplate":
      case "manageAppMember":
      case "deleteAppMember":

      case "runAppConfigTemplate":
      case "deleteCoupon":
      case "shareMessage":
      case "removeCalendar":
      case "resetAIChat":
      case "setPollResult":
      case "getUsersPaymentOrders":
      case "viewBotToken":
      case "getOrderDetails":
      // case "getPollResult":
      // case "publishPollResult":
      case "getMapMarkers":
      case "createMapMarker":
      case "getMapMarker":
      case "setMapMarker":
      case "removeMapMarker":
      case "messageAI":
      case "getAIHistory":
      case "clearAIHistory":
      case "getAIDefinition":
      case "updateAIDefinition":
      case "generateAIApp":

      case "searchItems":
      case "createArticle":
      case "setSignupStatus":
      case "generateAIAppFromAITemplate":

      case "listPartners":
      case "setAppStats":
      case "listAppFunnel":

      case "listFunnelMetrics":
      case "listFunnelKpiSummary":

      case "listSignupSourceMetrics":
      case "listSignupConversionCohorts":

      case "listAppPayments":
      case "listAppRevenueSummary":
      case "listPaymentMetrics":
      case "listPaymentRetentionSummary":
      case "listRevenueKpiSummary":
      case "listSubscriptionMetrics":
      case "setAppBuildRate":
      case "setAppPaymentDate":
      case "getCustomerToken":
      case "sendDeviceCalendar":

      case "addToBlacklist":
      case "getTagsValue":
      case "setServiceOrderStatus":
      case "getCustomerToken":

      case "setWorkflow":
      case "getWorkflow":
      case "deleteWorkflow":
      case "listWorkflow":

      case "createTeamAccount":
      case "setTeamAccount":

      case "setCustomSchema":
      case "getCustomSchema":
      case "deleteCustomSchema":
      case "listCustomSchema":

      case "setContent":
      case "getContent":
      case "deleteContent":
      case "listContent":

      case "listTopics":
      case "setTopic":
      case "deleteTopic":

      case "listAppPermission":
      case "setAppPermission":
      case "deleteAppPermission":
      case "getTeamAccount":
      case "listTeamAccount":
      case "deleteTeamAccount":

      case "listETemplates":
      case "setETemplate":
      case "getETemplate":
      case "deleteETemplate":

      case "listNotificationTemplates":
      case "setNotificationTemplate":
      case "getNotificationTemplate":
      case "deleteNotificationTemplate":

      case "listAITemplates":

      case "getMyProfiles":
      case "updateMyAccount":

      case "sendEmail":
      case "listEmails":
      case "getEmailDetails":
      case "deleteEmailsFromHistory":
      case "listCatalog":
      case "setCatalog":
      case "getCatalog":
      case "deleteCatalog":

      case "startAIBuilder":
      case "messageAIModule":
      case "maintenance":
      case "setProfile":
      case "sendSms":
      case "listSms":
      case "getSmsDetails":
      case "deleteSmsFromHistory":
      case "listNotifications":
      case "deleteNotificationsFromHistory":
      case "listRequestsToCheck":
      case "processMakerCheckerRecord":
      case "removeChatTags":
      case "listSMSTemplate":
      case "getSMSTemplate":
      case "setSMSTemplate":
      case "deleteSMSTemplate":
      case "getReviews":
      case "setReviewStatus":
      case "setMessageTemplate":
      case "getMessageTemplate":
      case "deleteMessageTemplate":
      case "listMessageTemplate":
      case "getMediaFile":
      case "getArticle":
      case "listBranch":
      case "setBranch":
      case "getBranch":
      case "deleteBranch":
      case "setBranchUser":
      case "removeBranchUser":
      case "listBranchUser":

      case "listVendors":
      case "setVendor":
      case "getVendor":
      case "deleteVendor":
      case "listGeoLocation":
      case "setGeoLocation":
      case "deleteGeoLocation":
      case "getGeoLocation":
      case "listZones":
      case "setZone":
      case "getZone":
      case "deleteZone":
      case "sendNotification":
      case "setCategory":
      case "getCategory":
      case "listCategory":
      case "deleteCategory":

      case "listOrderRequest":
      case "getOrderRequest":
      case "setOrderRequest":
      case "listOffers":
      this.sendTheRequest(
          JSON.stringify({
            ...data,
          })
        );
        break;
    }
  }

  errorMessage(errorCode) {
    let errorMsg : string =null;
    let label : string = 'Action failed';
    switch (errorCode) {
        case 100011:
        errorMsg = 'You must be an administrator of this chat to perform this task.';
        break;
        case 500040:
        label =null
        errorMsg = 'You are not a member or administrator of this chat.';
        break;
    }
    if (errorMsg){
      Swal.fire({
      title:label,
      text: errorMsg,
      icon: "error",
      confirmButtonText: 'Close',
      confirmButtonColor: '#556ee6'
    });
    }
  }

  sleep(ms: number) {
    return new Promise((val) => setTimeout(val, ms));
  }

  async logout() {
    // console.log("log 4");
    localStorage.removeItem("id");
    localStorage.removeItem("email");
    localStorage.removeItem("token");
    localStorage.removeItem("pcode");
    localStorage.removeItem("returnUrl");
    localStorage.removeItem("chat_id");
    localStorage.removeItem("app_id");
    localStorage.removeItem("reconnect");
    localStorage.removeItem("ndbx");
    localStorage.removeItem("vapp");
    localStorage.removeItem("version");
    localStorage.removeItem("template");

    localStorage.removeItem("start");
    this.signupStatus = null;
    // default stores and market
    localStorage.removeItem("store");
    localStorage.removeItem("storemenu");
    localStorage.removeItem("market");
    localStorage.removeItem("marketmenu");
    localStorage.removeItem("mode");
    localStorage.removeItem("custom");
    localStorage.removeItem("custommenu");
    // localStorage.removeItem("domain");

    // to check it later
    localStorage.removeItem("name");
    localStorage.removeItem("sapp_id");
    localStorage.removeItem("sapp_name");
    // unwanted
    localStorage.removeItem("cancel_end");
    localStorage.removeItem("countryIso");
    localStorage.removeItem("expire");
    localStorage.removeItem("plan_id");
    localStorage.removeItem("trial_end_date");
    //  localStorage.removeItem("app");

     localStorage.removeItem("debug_mode");
     localStorage.removeItem("signup_method");
     localStorage.removeItem("build_click");
     localStorage.removeItem("ptype");

     localStorage.removeItem("utm_source");
     localStorage.removeItem("utm_medium");
     localStorage.removeItem("utm_campaign");
     localStorage.removeItem("utm_term");
     localStorage.removeItem("ref");
     this.mdw.clearUserId();

     this.mdw.clear();
     this.router.navigate(["/hub/login"]);

    try {
        this.indexDBService.clearNdbxDatabases()
          .catch(() => {});
    } catch (error) {

    }

    this.resetColors();

    this._expiredContainer.next(undefined);
    this._genStatesContainer.next(undefined);

    localStorage.setItem("auth", "false");
    localStorage.setItem("reconnect", "false");
    if (this.ws) {
      // console.log("ws still open");
      this.ws.close(4999);
    } else {
      this.router.navigate(["/hub/login"]);
    }
  }

  logoutMultipleSessions() {
    localStorage.removeItem("id");
    localStorage.removeItem("email");
    localStorage.removeItem("token");
    localStorage.removeItem("pcode");
    localStorage.removeItem("returnUrl");
    this.mdw.clearUserId();
    this.mdw.clear();
    this.resetColors();
    localStorage.setItem("auth", "false");
    localStorage.setItem("reconnect", "false");
    this.router.navigate(["/hub/login"]);
  }

  resetColors(){
    this.es.broadcast("changeMode", "light");

    document.documentElement.style.setProperty("--card-body", "#ffffff");
    document.documentElement.style.setProperty("--card-text", "#343a40");

    document.documentElement.style.setProperty("--input-bg", "#ffffff");
    document.documentElement.style.setProperty("--input-text", "#000000");
    document.documentElement.style.setProperty("--input-border", "#000000");
    document.documentElement.style.setProperty("--input-addon-bg", "#32394e");
    document.documentElement.style.setProperty("--input-selected", "#585151");
    document.documentElement.style.setProperty("--input-placeholder", "#BEC3E4");

    document.documentElement.style.setProperty("--md-filled-button-container-color", "#007aff");
    document.documentElement.style.setProperty("--md-filled-button-label-text-color", "#ffffff");
    document.documentElement.style.setProperty("--md-filled-button-hover-label-text-color", "#ffffff");
    document.documentElement.style.setProperty("--md-filled-button-focus-label-text-color", "#ffffff");
    document.documentElement.style.setProperty("--md-filled-button-pressed-label-text-color", "#ffffff");

    document.body.style.backgroundColor = "#f8f8fb";
  }

  async reconnectWebsocket(token: any, id: any, email: any) {
    let request = fetch(environment.http_url, {
      method: "POST",
      mode: "cors",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        method: "reconnect",
        email: email,
        id: id,
        token: token,
      }),
    });

    request
      .then((response: any) => {
        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data.token != null && data.email != null && data.id != null) {
          this.sendRequest(
            JSON.stringify({
              method: "TOKEN_AUTH",
              token: data.token,
              email: data.email,
              rem: true,
              verion: 2,
            })
          );
        } else {
          localStorage.setItem("auth", "false");
        }
      })
      .catch((err: any) => {});
  }

  isTabletView(){
    if(window.innerWidth < 768){
      return true;
    }
    return false;
  }

  handleServerError(data){
    if (data.error) {
      switch (Number(data.error)) {
        case ServerErrors.TokenExpired:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.TokenExpired], 'error');
          break;
        case ServerErrors.NoPermission:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.NoPermission], 'error');
          break;
        case ServerErrors.AuthError:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AuthError], 'error');
          break;
        case ServerErrors.MultiLogin:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.MultiLogin], 'error');
          break;
        case ServerErrors.OldPasswordNotCorrect:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.OldPasswordNotCorrect], 'error');
          break;
        case ServerErrors.PasswordTooShort:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.PasswordTooShort], 'error');
          break;
        case ServerErrors.PasswordTooLong:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.PasswordTooLong], 'error');
          break;
        case ServerErrors.PasswordMustContainLowerCase:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.PasswordMustContainLowerCase], 'error');
          break;
        case ServerErrors.PasswordMustContainUpperCase:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.PasswordMustContainUpperCase], 'error');
          break;
        case ServerErrors.PasswordMustContainDigit:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.PasswordMustContainDigit], 'error');
          break;
        case ServerErrors.PasswordMustContainSpecial:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.PasswordMustContainSpecial], 'error');
          break;
        case ServerErrors.PasswordMatchesPattern:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.PasswordMatchesPattern], 'error');
          break;
        case ServerErrors.PasswordMatchesDictionary:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.PasswordMatchesDictionary], 'error');
          break;
        case ServerErrors.PasswordInHistory:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.PasswordInHistory], 'error');
          break;
        case ServerErrors.PasswordsDoNotMatch:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.PasswordsDoNotMatch], 'error');
          break;
        case ServerErrors.GoogleAccountNotOpened:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.GoogleAccountNotOpened], 'error');
          break;
        case ServerErrors.GoogleReleaseManagerNotSetup:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.GoogleReleaseManagerNotSetup], 'error');
          break;
        case ServerErrors.AppNameNotProvided:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AppNameNotProvided], 'error');
          break;
        case ServerErrors.GoogleScJsonNotProvided:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.GoogleScJsonNotProvided], 'error');
          break;
        case ServerErrors.AppleAccountNotOpened:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AppleAccountNotOpened], 'error');
          break;
        case ServerErrors.AppleAppManagerNotSetup:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AppleAppManagerNotSetup], 'error');
          break;
        case ServerErrors.AppleAppNameNotProvided:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AppleAppNameNotProvided], 'error');
          break;
        case ServerErrors.GooglePackageIdNotProvided:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.GooglePackageIdNotProvided], 'error');
          break;
        case ServerErrors.AppleBundleIdNotProvided:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AppleBundleIdNotProvided], 'error');
          break;
        case ServerErrors.AppleTeamNameNotProvided:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AppleTeamNameNotProvided], 'error');
          break;
        case ServerErrors.GoogleScJsonInvalidFormat:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.GoogleScJsonInvalidFormat], 'error');
          break;
        case ServerErrors.AppSpecificPasswordNotProvided:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AppSpecificPasswordNotProvided], 'error');
          break;
        case ServerErrors.GooglePackageIdHasInvalidFormat:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.GooglePackageIdHasInvalidFormat], 'error');
          break;
        case ServerErrors.AppleBundleIdHasInvalidFormat:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AppleBundleIdHasInvalidFormat], 'error');
          break;
        case ServerErrors.AppleDeveloperPasswordNotProvided:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AppleDeveloperPasswordNotProvided], 'error');
          break;
        case ServerErrors.ApplePushNotiKeyNotProiveded:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.ApplePushNotiKeyNotProiveded], 'error');
          break;
        case ServerErrors.AppleUserNotProvided:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AppleUserNotProvided], 'error');
          break;
        case ServerErrors.AndroidFormatHasWrongValue:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AndroidFormatHasWrongValue], 'error');
          break;
        case ServerErrors.AppleAppManagerNotConfirmed:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AppleAppManagerNotConfirmed], 'error');
          break;
        case ServerErrors.AppNameIsAlreadyUsed:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.AppNameIsAlreadyUsed], 'error');
          break;
        case ServerErrors.DifferentCurrency:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.DifferentCurrency], 'error');
          break;
        case ServerErrors.SKUIsAlreadyUsed:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.SKUIsAlreadyUsed], 'error');
          break;
        case ServerErrors.PatternNotmatched:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.PatternNotmatched], 'error');
          break;
        case ServerErrors.InvalidPattern:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.InvalidPattern], 'error');
          break;
        case ServerErrors.NotifierIsAlreadyExist:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.NotifierIsAlreadyExist], 'error');
          break;
        case ServerErrors.DifferentSubChannels:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.DifferentSubChannels], 'error');
          break;
        case ServerErrors.NotAllowed:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.NotAllowed], 'error');
          break;
        case ServerErrors.UserBanned:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.UserBanned], 'error');
          break;
        case ServerErrors.DeviceBanned:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.DeviceBanned], 'error');
          break;
        case ServerErrors.RegionError:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.RegionError], 'error');
          break;
        case ServerErrors.DeleteChatError:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.DeleteChatError], 'error');
          break;
        case ServerErrors.FailedTestVendor:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.FailedTestVendor], 'error');
          break;
        case ServerErrors.ConfigurationTestVendorNotExist:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.ConfigurationTestVendorNotExist], 'error');
          break;
        case ServerErrors.MissingDataForTest:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.MissingDataForTest], 'error');
          break;
        case ServerErrors.Blocked:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.Blocked], 'error');
          break;
        case ServerErrors.WRONG_FORMAT:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.WRONG_FORMAT], 'error');
          break;
        case ServerErrors.TacIsWrong:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.TacIsWrong], 'error');
          break;
        case ServerErrors.INVALID_NUMBER:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.INVALID_NUMBER], 'error');
          break;
        case ServerErrors.UniqueBotNameError:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.UniqueBotNameError], 'error');
          break;
        case ServerErrors.DeleteChatError:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.DeleteChatError], 'error');
          break;
        case ServerErrors.UnAuthenticated:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.UnAuthenticated], 'error');
          break;
        case ServerErrors.MAXIMUM_BUILD:
          this._maximumBuildContainer.next(true);
          break;
        case ServerErrors.APP_EXPIRED:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.APP_EXPIRED], 'error');
          break;
        case ServerErrors.OVER_LAPING_DAYS_AVILABOL:
          Swal.fire('Error',SERVER_ERROR_MESSAGES[ServerErrors.OVER_LAPING_DAYS_AVILABOL], 'error');
          break;
        default:
          break;
      }
    }
  }
}
